import React from 'react';
import { Icon, Button, Input, Table, Divider, Modal, message, Tooltip } from 'antd';

import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import createHistory from 'history/createHashHistory';//路由切换地址

import EventSet from "./../../../../../assets/PubJs/hcPub"//公用的所有事件
import $ from "jquery"
const confirm = Modal.confirm;
const history = createHistory();//定义history路由

//添加成员
let _AddPeople = null;
let time1 = null
class AddPeople extends React.Component {
    state = {
        visible: false,
        showTime: true,
        yzm: "",
        H: "00",
        M: "00",
        S: "00",
    };
    showModal = () => {
       
        let _this = this;
        let setData = {
            UserCode: EventSet.getUserInfo().CU_Code,
            CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/InvitingCodeValidate",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                console.log(res)
                if (res.split("|")[0] === "0") {
                    _this.setState({
                        visible: true,
                    });
                    _this.setState({
                        showTime: true,
                    });
                }else if(res.split("|")[0] === "2") {
                    _this.setState({
                        visible: false,
                    });
                    message.error(res.split("|")[1])
                } else {
                    _this.setState({
                        visible: true,
                    });
                    _this.djs(res.split("|")[2])
                    _this.setState({
                        showTime: false,
                        yzm: res.split("|")[1],
                    });
                }
            },
            error: function (data,err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    };

    djs = (nowTime) => {
        let _this = this
        let timeArrStart = EventSet.getSurplusTime(nowTime);
        _this.setState({

            H: timeArrStart[1],
            M: timeArrStart[2],
            S: timeArrStart[3],
        });

        time1 = setInterval(function () {
            let timeArr = EventSet.getSurplusTime(nowTime);
            _this.setState({
                H: timeArr[1],
                M: timeArr[2],
                S: timeArr[3],
            }, () => {
                if (timeArr[0] > 0) {
                    _this.setState({
                        showTime: true,
                        H: "00",
                        M: "00",
                        S: "00",
                    });
                    clearInterval(time1);
                }
            });
        }, 1000)
    }

    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    };
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
       
    };

    //生成邀请码
    generate() {
        let _this = this
        this.setState({
            showTime: false
        });
        let CreateDate1= new Date()
        let setData = {
            UserCode: EventSet.getUserInfo().CU_Code,
            CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
            CreateDate: EventSet.GetDate(CreateDate1, "yyyy-MM-dd hh:mm:ss"),
        };
        //console.log(setData,"awdawd")
        $.ajax({
            url: Hcurl + "/CompanyCore/AddMembers",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                let a = new Date()
                _this.djs(JSON.parse(res).inviteTime.replace(/\-/g,"/"))
                _this.setState({
                    showTime: false,
                    yzm: JSON.parse(res).inviteCode,
                });
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    //复制邀请码
    copy() {
        let Url2 = document.getElementById("yzm");
        Url2.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
    }

    componentDidMount() {
        _AddPeople = this
    }

    render() {
        return (
            <div>
                <Modal
                    title="添加成员"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={null}
                >
                    <div style={{ minHeight: 280 }}>
                        <div className={"AddPeopleModal"}>
                            {
                                this.state.showTime ? <div>
                                    <p style={{ textAlign: "center" }}>请选择点击下面按钮生成邀请码</p>
                                    <p style={{ textAlign: "center", marginTop: 44 }}><Button type="primary"
                                        onClick={this.generate.bind(this)}>生成邀请码</Button>
                                    </p>
                                </div> : <div>
                                        <p style={{ textAlign: "center", marginTop: 34, color: "#666", fontSize: 16 }}>该邀请码24小时有效，逾期后请重新生成</p>
                                        <p style={{ textAlign: "center", marginTop: 34 }}>
                                            <Input id="yzm" value={this.state.yzm} style={{ width: 180, marginRight: 8 }} readOnly />
                                            <Button onClick={this.copy.bind(this)}>点击复制</Button>
                                        </p>
                                        <p style={{ textAlign: "center", marginTop: 24, color: "red", fontSize: 16 }}>
                                            剩余时间 : {this.state.H}:{this.state.M}:{this.state.S}
                                        </p>
                                        <p style={{ textAlign: "center", marginTop: 44, color: "#333", fontSize: 18 }}>
                                            复制上方邀请码，让对方加入你的企业吧！</p>
                                    </div>
                            }
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

//移交管理权限
let _RemoveJur = null;
let time=null;
class RemoveJur extends React.Component {
    state = {
        visible: false,
        name: "",
        phone: "",
        djs: "获取验证码",
        OperateUserCode:'',
    };
    showModal = (record) => {
        let phone = EventSet.getUserInfo().linkPhone;
        phone = phone.substr(0, 3) + phone.substr(3, 6).replace(/\d/ig, "*") + phone.substr(9, 2);
        this.setState({
            visible: true,
            name: record.CU_LoginName,
            userName: record.CU_UserName,
            phone: phone,
            yzm: "",
            OperateUserCode:record.UCR_ComUserID,
            djs: "获取验证码"
        });
        clearInterval(time);
    };
    handleOk = (e) => {
        let _this = this;
        if (_this.state.yzm == null || _this.state.yzm == "") {
            message.error("请输入验证码")
            return
        }
        $.ajax({
            url:Hcurl+"/HomePage/CheckValidCode",
            type:"post",
            async:false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            data:{
                Type: '7',
                UserCode:JSON.parse(localStorage.getItem("userInfo")).CU_Code,
                // tele:EventSet.getUserInfo().linkPhone,//手机号
                // type:'jiangsu',//来源识别号，一般是项目名称，建议英文
		        Code:_this.state.yzm,//用户输入的验证码
            },
            success:function(res){
                if (res.indexOf('false')>-1) {
                    message.error("验证码错误")
                } else {
                    let setData = {
                        UserCode: EventSet.getUserInfo().CU_Code,
                        CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
                        OperateUserCode:_RemoveJur.state.OperateUserCode,
                        LoginName: _RemoveJur.state.name,
                        type: "1"
                    };
                    //console.log(setData)
                    $.ajax({
                        url: Hcurl + "/CompanyCore/UserOperation",
                        type: "post",
                        data: setData,
                        async: false,
                        headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        success: function (res) {
                            if (res.split("|")[0] === "true") {
                                message.success(res.split("|")[1])
                                let userInfo = JSON.parse(localStorage.userInfo);
                                userInfo.UCR_IsAdmin = "0";
                                localStorage.setItem("userInfo", JSON.stringify(userInfo))
                                history.push({
                                    pathname: "/Content/Business/CompanyList/test",
                                })
                            } else {
                                message.error(res.split("|")[1])
                            }
                        },
                        error: function (data,err) {
                            if (!JSON.parse(data.responseText).success && data.status === 403) {
                                history.push({ "pathname": "/err" })
                            } else {
                                message.error('抱歉，您无权访问该页面')
                                setTimeout(() => {
                                    history.push({ "pathname": "/Content/Business/CompanyList" })
                                }, 200);
                            }
                        }
                    })
                    _RemoveJur.setState({
                        visible: false,
                    });
                }
            }})
        
    };

    handleCancel = (e) => {
        this.setState({
            visible: false,
           
        });

       
    };

    onChangeyzm = (e) => {
        this.setState({ yzm: e.target.value });
    };

    //倒计时
    djs() {
        let _this = this;
        let num = 60;
        num--;
        _this.setState({
            djs: num < 10 ? '0' + num + 's' : num + 's'
        });
         time = setInterval(function () {
            if (num === 1) {
                num = 10;
                _this.setState({
                    djs: "获取验证码"
                });
                clearInterval(time)
            } else {
                num--;

                _this.setState({
                    djs: num < 10 ? '0' + num + 's' : num + 's'
                })
            }
        }, 1000)
    }

    //fas验证码
    sendYZM() {
        let _this = this;
        this.djs()
        $.ajax({
            url:Hcurl + "/HomePage/SendComPhoneValidCode",
            type:"post",
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            data: {
                Type: '7',
                UserCode:JSON.parse(localStorage.getItem("userInfo")).CU_Code,
            },
            success:function(res){
                if (res.indexOf("true") >= 0) {
                    message.success('验证码发送成功');
                } else {
                    message.error("验证码发送失败");
                    _this.setState({
                        djs: "获取验证码"
                    });
                    clearInterval(time);
                }
            }
        })
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    }
    componentDidMount() {
        _RemoveJur = this
    }

    render() {
        return (
            <div>
                <Modal
                    title="移交权限"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <div style={{ minHeight: 180, padding: "0 40px" }}>
                        <p style={{ marginTop: "34px" }}>移交权限至用户“{this.state.userName}({this.state.name})”</p>
                        <Input
                            value={this.state.phone}
                            style={{ marginTop: "2px" }}
                            disabled
                            prefix={<Icon type="tablet" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        />
                        <Input
                            value={this.state.yzm}
                            style={{ marginTop: "24px", display: "inline-block", width: "65%" }}
                            placeholder="输入验证码"
                            onChange={this.onChangeyzm}
                        />
                        <Button
                            disabled={this.state.djs === "获取验证码" ? false : true}
                            onClick={this.sendYZM.bind(this)}
                            style={{ margin: "24px 0 0 3%", display: "inline-block", width: "32%" }}
                        >
                            {this.state.djs}
                        </Button>
                        <p style={{ marginTop: "34px", color: "red" }}>注：移交管理权限后，您的权限将自动降级为“普通成员”权限</p>
                    </div>
                </Modal>
            </div>
        );
    }
}

//Tab--企业成员组件
class TabPeople extends React.Component {
    state = {
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        sorters: null,
        loading: false,
        pagetotalCount: 0,
        visible: false,
        isAdmin: "block",
        keyWordVal: ""
    };

    //分页、排序等改变事件
    handleTableChange = (pagination, filters, sorter) => {
        let _this = this;
        this.setState({
            pagination: pagination,
            sorters: sorter
        }, () => {
            _this.fench()
        });
    };

    //表格的渲染
    fench = () => {
        let _this = this
        this.setState({ loading: true });
        const pagination = { ...this.state.pagination };

        let setData = {
            pageSize: pagination.pageSize,
            pageNo: pagination.current,
            keyWord: _this.state.keyWordVal,
            companyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/GetCompanyList",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                let data = JSON.parse(res)
                //console.log(data)
                pagination.total = Number(data.TotalCount);
                _this.setState({
                    loading: false,
                    data: data.Rows,
                    pagination: pagination,
                    pagetotalCount: data.TotalCount
                })
                _this.getAllPage()
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    };


    //获取当前表格共多少页
    getAllPage() {
        let _this = this
        setTimeout(function () {
            let count = _this.state.pagination.total
            let size = _this.state.pagination.pageSize
            if (count % size !== 0) {
                let num = count - count % size
                _this.setState({
                    allPage: num / size + 1
                })
            } else {
                _this.setState({
                    allPage: count / size
                })
            }
        }, 20)
    }

    //添加成员
    AddPeople() {
        _AddPeople.showModal()
    }
    getCom_Name = () => {  //获取先行和解默认企业信息
        $.ajax({
            url: Hcurl + "/CompanyCore/GetXXHJCompanyDefultName?u_code=" + EventSet.getUserInfo().CU_Code,
            type: 'post',
            success: function (data) {
                console.log(data, 'success');
                let userInfo = JSON.parse(localStorage.userInfo);
                userInfo.xxhjcompanycode = data.split("|")[1];
                userInfo.XXHJCom_Name = data.split("|")[2];
                localStorage.setItem("userInfo", JSON.stringify(userInfo))
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }

        })
    }
    //移除成员
    RemovePeople = (record) => {
        let _this = this;
        confirm({
            title: '移除成员',
            content: '当前成员被移除后将自动对企业进行解绑操作，确定将当前成员“' + record.CU_UserName + '”移除吗？',
            cancelText: "取消",
            okText: "确定",
            onOk() {
                let setData = {
                    UserCode: EventSet.getUserInfo().CU_Code,
                    CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
                    LoginName: record.CU_LoginName,
                    OperateUserCode: record.UCR_ComUserID,
                    type: "0"
                };
                //console.log(setData)
                $.ajax({
                    url: Hcurl + "/CompanyCore/UserOperation",
                    type: "post",
                    data: setData,
                    async: false,
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    success: function (res) {
                        if (res.split("|")[0] === "true") {
                            message.success(res.split("|")[1])
                            const pagination = { ..._this.state.pagination };
                            pagination.current = 1;
                            _this.setState({
                                pagination,
                            });
                            setTimeout(() => {
                                _this.fench()
                            }, 50);
                            
                        } else {
                            message.error(res.split("|")[1])
                        }
                        _this.getCom_Name();
                    },
                    error: function (data,err) {
                        if (!JSON.parse(data.responseText).success && data.status === 403) {
                            history.push({ "pathname": "/err" })
                        } else {
                            message.error('抱歉，您无权访问该页面')
                            setTimeout(() => {
                                history.push({ "pathname": "/Content/Business/CompanyList" })
                            }, 200);
                        }
                    }
                })
            },
            onCancel() {

            },
        });
    }

    //点击进行值班
    Zhiban = (record) => {
        let _this = this;
        let setData = {
            UserCode: EventSet.getUserInfo().CU_Code,
            CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
            LoginName: record.CU_LoginName,
            OperateUserCode: record.UCR_ComUserID,
            IsOnDuty: "1",
            type: "2"
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/UserOperation",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                if (res.split("|")[0] === "true") {
                    message.success(res.split("|")[1])
                    _this.fench()
                } else {
                    message.error(res.split("|")[1])
                }
            },
            error: function (data,err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error('抱歉，您无权访问该页面')
                    setTimeout(() => {
                        history.push({ "pathname": "/Content/Business/CompanyList" })
                    }, 200);
                }
            }
        })
    }

    //点击取消值班
    QZhiban = (record) => {
        console.log(record)
        let _this = this;
        let setData = {
            UserCode: EventSet.getUserInfo().CU_Code,
            CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
            LoginName: record.CU_LoginName,
            OperateUserCode: record.UCR_ComUserID,
            IsOnDuty: "0",
            type: "2"
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/UserOperation",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                if (res.split("|")[0] === "true") {
                    message.success(res.split("|")[1])
                    _this.fench()
                } else {
                    Modal.info({
                        title: '提示',
                        content: res.split("|")[1],
                        okText: "知道啦"
                    });
                    //message.error(res.split("|")[1])
                }
            },
            error: function (data,err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error('抱歉，您无权访问该页面')
                    setTimeout(() => {
                        history.push({ "pathname": "/Content/Business/CompanyList" })
                    }, 200);
                    
                }
            }
        })
    }

    keyWordChange(e) {
        this.setState({
            keyWordVal: e.target.value
        })
    }
    searchType=()=>{
        let _this =this
        const pagination = { ..._this.state.pagination };
        pagination.current = 1;
        _this.setState({
            pagination,
        });
        setTimeout(() => {
            _this.fench()
        }, 50);
    }
    componentDidMount() {
        this.fench()
        let _this = this;
        if (EventSet.getUserInfo().UCR_IsAdmin === "1") {
            _this.setState({
                isAdmin: "block"
            })
        } else {
            _this.setState({
                isAdmin: "none"
            })
        }
    }

    render() {
        const aTitle = <Tooltip placement="top" title={"值班： 表示默认接收业务单在流转过程中的各类提醒短信。"}>操作&nbsp;&nbsp;<Icon type="info-circle-o" /></Tooltip>
        const columns = [{
            title: '用户名',
            dataIndex: 'CU_LoginName',

        }, {
            title: '姓名',
            dataIndex: 'CU_UserName',
        }, {
            title: '性别',
                dataIndex: 'CU_Sex',
                render: (text, record) => {
                    return (record.CU_Sex == "" ? "保密" : record.CU_Sex)
                }
        }, {
            title: '身份称谓',
            dataIndex: 'CU_Title',
        }, {
            title: '手机号码',
            dataIndex: 'CU_LinkPhone',
        }, {
            title: '权限',
            dataIndex: 'UCR_IsAdmin',
        }
            , {
                title: aTitle,
            render: (text, record) => {
                return (
                    JSON.parse(localStorage.getItem('companyInfo')).UCR_IsAdmin === "0" ? <span>
                        <a disabled>移除成员</a>
                        <Divider type="vertical" />
                        <a disabled>移交管理权限</a>
                        <Divider type="vertical" />
                        {record.UCR_IsOnDuty === 0 ? <a disabled>值班</a> : <a disabled>取消值班</a>}
                    </span> : (record.UCR_IsAdmin !== "管理员" ? <span>
                        <a onClick={() => this.RemovePeople(record)}>移除成员</a>
                        <Divider type="vertical" />
                        <a onClick={() => _RemoveJur.showModal(record)}>移交管理权限</a>
                        <Divider type="vertical" />
                        {record.UCR_IsOnDuty === 0 ? <a onClick={() => this.Zhiban(record)}>值班</a> : <a onClick={() => this.QZhiban(record)}>取消值班</a>}

                    </span> : <span>
                            <a disabled>移除成员</a>
                            <Divider type="vertical" />
                            <a disabled>移交管理权限</a>
                            <Divider type="vertical" />
                            {record.UCR_IsOnDuty === 0 ? <a onClick={() => this.Zhiban(record)}>值班</a> : <a onClick={() => this.QZhiban(record)}>取消值班</a>}
                        </span>)

                )
            },
        }];
        return (
            <div className={"TabPeople"}>
                <AddPeople />
                <RemoveJur />
                <div className={"TabPeopleTop clearFloat"}>
                    { JSON.parse(localStorage.getItem('userInfo')).UCR_IsAdmin != "0"?<Button onClick={this.AddPeople} style={{ float: "left",  }}>添加成员</Button>:''}
                    <Button onClick={this.searchType} type="primary" style={{ float: "right" }}>搜索</Button>
                    <Input onChange={this.keyWordChange.bind(this)} value={this.state.keyWordVal} style={{ float: "right", width: 320, marginRight: 42 }} placeholder="请输入关键字搜索" />
                </div>

                <div style={{ position: "relative", margin: "20px 0" }}>
                    <LocaleProvider locale={zh_CN}>
                        <Table
                            rowKey={record => record.ID}
                            pagination={this.state.pagination}
                            loading={this.state.loading}
                            onChange={this.handleTableChange}
                            size="middle"
                            bordered
                            columns={columns}
                            dataSource={this.state.data}
                        />
                    </LocaleProvider>
                    <div style={{ position: "absolute", bottom: "20px", left: "0px" }}>
                        共 {this.state.pagetotalCount}条记录，第{this.state.pagination.current}/{this.state.allPage}页
                    </div>
                </div>
            </div>

        )
    }
}

export default TabPeople


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyListTab/TabPeople.js